export class UploadInputConstants {
  public static FILE_EXTENSION_REGEXP = new RegExp('(?:.([^.]+))?$');
  public static CHAR_PIXEL_RATIO = 11;
}
